<template>
	<half-circle-spinner
		:animation-duration="1000"
		:size="40"
		:color="spinnerColor"
	></half-circle-spinner>
</template>

<script>
import { HalfCircleSpinner } from 'epic-spinners'

export default {
	components: {
		HalfCircleSpinner,
	},
	data() {
		return {
			// Define other data properties if needed
		}
	},
	computed: {
		// Use a computed property to dynamically get the CSS variable value
		spinnerColor() {
			// Get the value of --tint-color from the root (document) level
			// This assumes --tint-color is defined at the :root or body level in your CSS
			// You might need to adjust the selector if --tint-color is defined elsewhere
			const color = getComputedStyle(document.documentElement).getPropertyValue('--tint-color').trim();
			// Provide a fallback color in case --tint-color is not defined
			return color || '#bc0000';
		}
	},
}
</script>
